import React from "react";

interface CopyToClipboardIconProps {
  size?: string;
}

const CopyToClipboardIcon = (props: CopyToClipboardIconProps) => {
  const { size = "12px" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none">
      <path
        d="M10 1H5C4.4485 1 4 1.4485 4 2V4H2C1.4485 4 1 4.4485 1 5V10C1 10.5515 1.4485 11 2 11H7C7.5515 11 8 10.5515 8 10V8H10C10.5515 8 11 7.5515 11 7V2C11 1.4485 10.5515 1 10 1ZM2 10V5H7L7.001 10H2ZM10 7H8V5C8 4.4485 7.5515 4 7 4H5V2H10V7Z"
        fill="#002035"
      />
    </svg>
  );
};

export default CopyToClipboardIcon;
